















































import {Component, Vue, Watch} from "vue-property-decorator";
import {mapState} from "vuex";
import Auth from "@/components/Auth.vue";
import ProductDetail from "@/components/ProductDetail.vue";
import NewsletterDialog from "@/components/NewsletterDialog.vue";
import PayPalPaymentStatus from "@/components/PayPalPaymentStatus.vue";
import ReservationDialog from "@/components/experiences/ReservationDialog.vue";
import CellarImagesDialog from "@/components/cellars/CellarImagesDialog.vue";
import {Dialog} from "@/store/modules/appModule";
import ConfirmationDialog from "@/components/stateless/ConfirmationDialog.vue";

@Component({
  components: {
    Auth,
    CellarImagesDialog,
    ProductDetail,
    ConfirmationDialog,
    PayPalPaymentStatus,
    ReservationDialog,
    NewsletterDialog
  },
  computed: {
    ...mapState({
      dialogManager: (state: any) => state.app.dialogManager
    })
  }
})
export default class DialogManager extends Vue {
  dialogManager!: Dialog;
  dialog: Dialog = {};

  @Watch("dialogManager", {immediate: true, deep: true})
  onDialogStateChange(val: any) {
    this.dialog = {...val};
    // Reset dialog state if type is null
  }

  // Check outside popup click case
  @Watch("dialog.state")
  onClickOutside(val: any) {
    if (!val) {
      this.dialog.type = null;
      this.dialog.childData = null;
    }
  }
}
